import React from 'react'

export interface ILabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
    labelText?: React.ReactNode
    isRequired?: boolean
    hasError?: boolean
}

export const LABEL_CLASS = 'form-group flex flex-col relative text-destaques-hover font-sora'

/**
 * Rótulo dos campos da loja: o texto (com " *" quando obrigatório) e o campo embaixo, rosa quando há erro. O `<label>`
 * envolve só o texto e se liga ao campo pelo `htmlFor`: o erro e os botões ao lado do campo (olho da senha, "OK" do CEP)
 * ficam fora do nome acessível.
 */
const Label: React.FC<ILabelProps> = ({
    labelText,
    isRequired,
    hasError,
    className = '',
    children,
    htmlFor,
    ...rest
}) => {
    return (
        <div className={`${LABEL_CLASS} ${className} ${hasError ? 'text-jolly-rose' : ''}`}>
            {labelText || isRequired ? (
                <label htmlFor={htmlFor} {...rest}>
                    {labelText}
                    {isRequired && ' *'}
                </label>
            ) : null}
            {children}
        </div>
    )
}

export default Label
